import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Star } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";

export default function PostDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
    api.post(`/posts/${slug}/view`).catch(() => {});
  }, [slug]);

  if (notFound) {
    return (
      <div>
        <Navbar />
        <div className="max-w-3xl mx-auto px-6 pt-40 pb-24 text-center">
          <h1 className="font-serif-display text-4xl mb-4">Post not found</h1>
          <Link to="/blog" className="label-caps text-[0.7rem] text-[#7A1C28]">← Back to articles</Link>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div>
        <Navbar />
        <div className="max-w-3xl mx-auto px-6 pt-40 pb-24 text-[#737373]">Loading…</div>
      </div>
    );
  }

  const backTo = post.type === "review" ? "/reviews" : "/blog";

  return (
    <div>
      <Navbar />
      <article className="pt-28" data-testid="post-detail">
        {post.cover_image && (
          <div className="max-w-5xl mx-auto px-6 md:px-12">
            <div className="aspect-[16/9] overflow-hidden border border-[#E5E2D9]">
              <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
            </div>
          </div>
        )}
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-14">
          <Link to={backTo} className="inline-flex items-center gap-2 label-caps text-[0.7rem] text-[#7A1C28] mb-8 hover:gap-3 transition-all">
            <ArrowLeft size={16} /> Back
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <span className="label-caps text-[0.65rem] text-[#7A1C28]">
              {post.category || (post.type === "review" ? "Review" : "Article")}
            </span>
            {post.type === "review" && post.rating != null && (
              <span className="flex items-center gap-1 text-[#D4AF37] text-sm">
                <Star size={15} fill="#D4AF37" strokeWidth={0} /> {post.rating} / 5
              </span>
            )}
          </div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-light leading-tight mb-4">{post.title}</h1>
          {post.type === "review" && (post.production || post.venue) && (
            <p className="text-[#737373] mb-6">
              {post.production}{post.venue ? ` · ${post.venue}` : ""}{post.show_date ? ` · ${post.show_date}` : ""}
            </p>
          )}
          {post.excerpt && <p className="font-serif-display text-xl italic text-[#4A4A4A] mb-8">{post.excerpt}</p>}
          <div className="prose text-[#1A1A1A] leading-relaxed space-y-5 text-lg">
            {post.content.split("\n").filter(Boolean).map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>
      </article>
      <Footer />
    </div>
  );
}
